import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from '../index'

// Base selectors
export const selectDocuments = (state: RootState) => state.documents
export const selectExtractedData = (state: RootState) => state.documents.extractedData
export const selectTransactions = (state: RootState) => state.documents.transactions
export const selectValidationResult = (state: RootState) => state.documents.validationResult
export const selectDocumentsLoading = (state: RootState) => state.documents.loading
export const selectDocumentsError = (state: RootState) => state.documents.error

// Computed selectors
export const selectTransactionsByType = (type: 'credit' | 'debit') => createSelector(
  [selectTransactions],
  (transactions) => transactions.filter(t => t.type === type)
)

export const selectTransactionSummary = createSelector(
  [selectTransactions],
  (transactions) => {
    const credits = transactions.filter(t => t.type === 'credit')
    const debits = transactions.filter(t => t.type === 'debit')
    
    return {
      totalCredits: credits.reduce((sum, t) => sum + t.amount, 0),
      totalDebits: debits.reduce((sum, t) => sum + t.amount, 0),
      creditCount: credits.length,
      debitCount: debits.length,
      netFlow: credits.reduce((sum, t) => sum + t.amount, 0) - 
                debits.reduce((sum, t) => sum + t.amount, 0)
    }
  }
)

export const selectValidationIssues = createSelector(
  [selectValidationResult],
  (result) => result?.issues || []
)

export const selectValidationStatus = createSelector(
  [selectValidationResult],
  (result) => ({
    isValid: result?.isValid || false,
    hasWarnings: result?.issues.some(i => i.severity === 'warning') || false,
    hasErrors: result?.issues.some(i => i.severity === 'error') || false,
    issueCount: result?.issues.length || 0
  })
)
